import { render, staticRenderFns } from "./SlideProducts.vue?vue&type=template&id=a90c6fc0&scoped=true&"
import script from "./SlideProducts.vue?vue&type=script&lang=js&"
export * from "./SlideProducts.vue?vue&type=script&lang=js&"
import style0 from "./SlideProducts.vue?vue&type=style&index=0&id=a90c6fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90c6fc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSlideGroup,VSlideItem})
